exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".IJ0VP{padding-left:90px;padding-right:20px}._1nov7{font-family:Roboto,sans-serif;font-size:20px;color:#363636}._3vXWz{margin-bottom:20px}._3vXWz img{margin-top:10px}._3vXWz span{color:#e4002b;font-size:16px;font-weight:700}._1l8YA{color:#eee;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:140px}._33YyZ{color:#e4002b;font-size:25px;position:absolute;right:10px;bottom:-15px}._2bErR{color:#e4002b;background-color:#fff;border:0;margin-top:15px;cursor:pointer;width:250px;font-size:18px;text-align:left;padding:0}._2bErR:hover{cursor:pointer;text-decoration:underline}", ""]);

// exports
exports.locals = {
	"root": "IJ0VP",
	"container": "_1nov7",
	"validacion_row": "_3vXWz",
	"boton_rojo": "_1l8YA",
	"crossIcon": "_33YyZ",
	"boton_volver": "_2bErR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/ValidacionesTecnicas/ValidacionesTecnicas.css
// module id = 1146
// module chunks = 0 1 2